import { useEffect, useRef } from 'react';

interface useDoubleClickProps<T extends HTMLElement> {
    callback(e: MouseEvent): void;
    ref?: React.RefObject<T>;
}

/**
 *
 * @param ref Мы модем передать ref на текущий элемент, на который надо повесить обработку
 * Или создать новый ref - innerRef, повесить события и вернуть его.
 * @returns Ref с привязанным обработчиком двойного клика.
 */
export const useDoubleClick = <T extends HTMLElement>({ callback, ref }: useDoubleClickProps<T>) => {
    const innerRef = useRef<T>(null);
    const realRef = ref !== undefined ? ref : innerRef;

    useEffect(() => {
        const el = realRef.current;
        if (!el) return;

        el.addEventListener('dblclick', callback);

        return () => {
            el.removeEventListener('dblclick', callback);
        };
    }, [callback]);

    return realRef;
};
